import { Grid, Typography } from "@mui/material";
import { CardViewLabels } from "~/components/label";
import { FormatDate } from "~/lib/date";
import { Asset } from "~/pages/inventory/asset/types";
import { AssetScoreBox } from "../asset-score-box";
import { MondooLogoHorizontal } from "~/components/MondooLogoHorizontal/MondooLogoHorizontal";

type PrintAssetSummaryProps = {
  asset: Asset;
  showScore?: boolean;
};

export function PrintAssetHeader({
  asset,
  showScore = true,
}: PrintAssetSummaryProps) {
  return (
    <Grid
      container
      sx={{
        pb: 4,
        px: 4,
        borderBottom: "1px solid #DBDADD",
      }}
    >
      <Grid size="grow">
        <MondooLogoHorizontal color="#222222" />
        <Typography variant="h4" component="h1" mt={1} mb={2}>
          Asset: {asset.name}
        </Typography>
        <Typography mb={2}>Updated: {FormatDate(asset.updatedAt)}</Typography>
        <CardViewLabels labels={asset.labels} />
      </Grid>
      <Grid size="auto">
        {showScore && <AssetScoreBox score={asset.score} />}
      </Grid>
    </Grid>
  );
}
